export interface ITreeStructure {
    title: string,
    key: string,
    url: string,
    languageId: number,
    expanded: boolean,
    items: Array<ITreeStructure>
}

export interface ITreeitem {
    label: string,
    key: string,
    url: string,
    id: number,
    languageId: number,
    parentId: number,
    expandable: boolean,
    visible?: boolean,
    focused?: boolean,
    selected?: boolean,
    expanded?: boolean,
    domElement?: HTMLElement;
}

export class Treeitem implements ITreeitem {
    label: string;
    key: string;
    url: string;
    id: number;
    languageId: number;
    parentId: number;
    expandable: boolean;
    visible?: boolean;
    focused?: boolean;
    selected?: boolean;
    expanded?: boolean
    domElement?: HTMLElement;

    constructor(obj: ITreeitem)
     {
        this.label = obj.label;
        this.key = obj.key,
        this.url = obj.url,
        this.id = obj.id;
        this.languageId = obj.languageId;
        this.parentId = obj.parentId;
        this.expandable = obj.expandable || false;
        this.visible = obj.visible || false;
        this.focused = obj.focused || false;
        this.selected = obj.selected || false;
        this.expanded = obj.expanded || false;
        this.domElement = obj.domElement || null;
    }
}